import { getDeviceId } from '@chegg/fingerprint-web-sdk';
import { Mfa_Status, authenticateMfa, isGqlError, pollMfaByAppStatus } from '@chegg/one-auth-sdk';
import { handleGeneralError } from "./error";
import { routerSlice } from "../../slices/router";
import { getCallback } from "../../../utils/callbacks";
import { handleToastMessage } from "../utils/orchestrator.utils";
export { handleSent };
async function handleSent(getState, dispatch) {
  dispatch(routerSlice.actions.changeRoute('push_sent'));
  try {
    var _getState$authParams = getState().authParams,
      cheggMfaToken = _getState$authParams.cheggMfaToken,
      uuid = _getState$authParams.uuid;
    var args = {
      mfaToken: cheggMfaToken,
      userUuid: uuid,
      flow: 'pushSent',
      pollingOptions: getTimeout()
    };
    var response = await pollMfaByAppStatus(args);
    switch (response.status) {
      case Mfa_Status.VERIFIED:
        dispatch(routerSlice.actions.changeRoute('signing_in'));
        var deviceId = await getDfid(uuid);
        var tokens = await authenticateMfa({
          mfaToken: cheggMfaToken,
          otpToken: response.otpToken
        }, deviceId);
        getCallback('onSuccess')(tokens);
        break;
      case Mfa_Status.APP_DECLINED_PUSH:
        dispatch(routerSlice.actions.changeRoute('app_push_declined'));
        break;
      case Mfa_Status.BLOCKED:
        handleToastMessage(dispatch, 'blocked');
        break;
      case Mfa_Status.EXPIRED:
        handleToastMessage(dispatch, 'sent_session_expired');
        break;
      case Mfa_Status.SENT:
        break;
      default:
        handleGeneralError(dispatch);
        break;
    }
  } catch (e) {
    var error = e;
    if (isGqlError(error) && error.code === 'polling_timeout') {
      handleToastMessage(dispatch, 'sent_session_expired');
    } else {
      handleGeneralError(dispatch);
    }
  }
}

/* istanbul ignore next this is only used by testcafe */
function getTimeout() {
  var _window;
  var shortTimeout = ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.search.indexOf('MFA_DIALOG_TIMEOUT_TEST')) > -1;
  return {
    timeoutDuration: shortTimeout ? 2000 : undefined
  };
}
async function getDfid(uuid) {
  var dfid;
  try {
    var result = await getDeviceId({
      uvn: '',
      userUuid: uuid,
      platform: '',
      session_id: '',
      combined_uuid_uvn: '',
      hasSubscription: true,
      combined_uuid_sessionId: '',
      combined_uuid_uvn_sessionid: ''
    });
    dfid = result.DFID;
    return dfid;
    // eslint-disable-next-line no-empty
  } catch (e) {}
}